module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-forward-dd1748e5eea62753cdb29c8145fa731e.svg";